export enum AuthenticationState {
  Authenticated = 'authenticated',
  Unauthenticated = 'unauthenticated',
  Pending = 'pending',
}
